module.exports = __webpack_public_path__ + "img/c-technics-3.png";